export default "__VITE_ASSET__BdBTT_ty__"